import { EmployeeInfoModel } from "./employee-info.model";
import { EmployeeNoteModel } from "./employee-note.model";
import { EmployeeModel } from "./employee.model";

export class SetupEmployeeModel {
    clientModel: EmployeeModel
    clientInfoModel: EmployeeInfoModel
    clientNoteModel: EmployeeNoteModel

    constructor(
        clientModel: EmployeeModel,
        clientInfoModel: EmployeeInfoModel,
        clientNoteModel: EmployeeNoteModel
    ) {
        this.clientModel = clientModel
        this.clientInfoModel = clientInfoModel
        this.clientNoteModel = clientNoteModel
    }
}